<template>
  <div>
    <div v-if="!slug">
      <section>
        <h3>Marketing</h3>
      </section>
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'facebook-ads' },
            }"
          >
            <div class="box-content">
              <img width="180" src="@/assets/img/inter/facebook-ads.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'google-ads' },
            }"
          >
            <div class="box-content">
              <img width="180" src="@/assets/img/inter/gads.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt disabled-box">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'tiktok-ads' },
            }"
            :event="''"
          >
            <div class="box-content flex middle column">
              <img width="150" src="@/assets/img/inter/tiktok.png"/>
              <small class="tag" style="margin-top: 4px">EM BREVE</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt disabled-box">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'taboola-ads' },
            }"
            :event="''"
          >
            <div class="box-content center flex middle column">
              <img width="150" src="@/assets/img/inter/taboola.png"/>
              <small class="tag" style="margin-top: 4px">EM BREVE</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt disabled-box">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'outbrain-ads' },
            }"
            :event="''"
          >
            <div class="box-content center flex middle column">
              <img width="170" src="@/assets/img/inter/outbrain.png"/>
              <small class="tag" style="margin-top: 4px">EM BREVE</small>
            </div>
          </router-link>
        </div>
      </section>

      <section class="margin-top-l">
        <h3>Leads</h3>
      </section>

      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'active-campaign' },
            }"
          >
            <div class="box-content flex middle column">
              <img width="190" src="@/assets/img/inter/active-campaign.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>

            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'lead-lovers' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="180" src="@/assets/img/inter/leadlovers.svg"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'custom-leads' },
            }"
          >
            <div class="box-content center flex middle column">
                <h3>WEBHOOK PERSONALIZADO - LEADS</h3>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt disabled-box">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: '123mail' },
            }"
            :event="''"
          >
            <div class="box-content center flex middle column">
              <img width="170" src="@/assets/img/inter/123mail.png"/>
              <small class="tag" style="margin-top: 4px">EM BREVE</small>
            </div>
          </router-link>
        </div>
      </section>

      <section class="margin-top-l">
        <h3>Mensagens</h3>
      </section>

      <section class="grid-flex wrap">
        <div
            v-if="checkResource('tracking') "
            class="item flex-1 box flex middle center-txt"
          >
          <router-link
            :to="{ name: 'Track', params: {slug: 'whatsapp'} }"
          >
            <div class="box-content flex middle column">
              <img width="210" src="@/assets/img/inter/whatsapp.svg"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'tintim' },
            }"
          >
            <div class="box-content flex middle column">
              <img width="190" src="@/assets/img/inter/tintim.svg"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>

            </div>
          </router-link>
        </div>
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'umbler' },
            }"
          >
            <div class="box-content flex middle column">
              <img width="220" src="@/assets/img/inter/umbler.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>

            </div>
          </router-link>
        </div>
        
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'maxbot' },
            }"
          >
            <div class="box-content flex middle column">
              <img width="220" src="@/assets/img/inter/maxbot.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>

            </div>
          </router-link>
        </div>
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'custom-mensagens' },
            }"
          >
            <div class="box-content center flex middle column" style="height: 145px">
                <h3>WEBHOOK PERSONALIZADO - MENSAGENS</h3>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>
      </section>

      <section class="margin-top-l">
        <h3>Vendas</h3>
      </section>
      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'hotmart' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/hotmart.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'kiwify' },
            }"
          >
            <div class="box-content">
              <img width="130" src="@/assets/img/inter/kiwify.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'shopify' },
            }"
          >
            <div class="box-content">
              <img width="140" src="@/assets/img/inter/shopify.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'perfectpay' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/perfectpay.png"/>
            </div>
          </router-link>
        </div>

      

        <div v-if="checkResource('yampiv2')"  class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'yampiv2' },
            }"
          >
            <div class="box-content  center flex middle column">
              <img width="130" src="@/assets/img/inter/yampiv2.svg"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'digitalguru' },
            }"
          >
            <div class="box-content">
              <img width="260" src="@/assets/img/inter/digitalguru.svg"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'bagy' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="115" src="@/assets/img/inter/bagy.webp"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'ticto' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="180" src="@/assets/img/inter/ticto.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'cakto' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="180" src="@/assets/img/inter/cakto.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'vegacheckout' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="180" src="@/assets/img/inter/vegacheckout.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'hubla' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="180" src="@/assets/img/inter/hubla.svg"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'lpqv' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="150" src="@/assets/img/inter/lpqv.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'kirvano' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="190" src="@/assets/img/inter/kirvano.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>


        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'lastlink' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="130" src="@/assets/img/inter/lastlink.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>


        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'lojaintegrada' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="260" src="@/assets/img/inter/lojaintegrada.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'stripe' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="100" src="@/assets/img/inter/stripe.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>


        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'woocommerce' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="170" src="@/assets/img/inter/woocommerce.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'clickbank' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="170" src="@/assets/img/inter/clickbank.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'moovin' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="170" src="@/assets/img/inter/moovin.png"/>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>


        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'witure' },
            }"
          >
            <div class="box-content">
              <img width="110" src="@/assets/img/inter/witure.svg"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'payt' },
            }"
          >
            <div class="box-content">
              <img width="70" src="@/assets/img/inter/payt.png"/>
            </div>
          </router-link>
        </div>


        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'braip' },
            }"
          >
            <div class="box-content">
              <img width="110" src="@/assets/img/inter/braip.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'doppus' },
            }"
          >
            <div class="box-content">
              <img width="140" src="@/assets/img/inter/doppus.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'cartpanda' },
            }"
          >
            <div class="box-content">
              <img width="160" src="@/assets/img/inter/cartpanda.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'appmax' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/appmax.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'eduzz' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/eduzz.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'monetizze' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/monetizze.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'evermart' },
            }"
          >
            <div class="box-content">
              <img width="150" src="@/assets/img/inter/evermart.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'greenn' },
            }"
          >
            <div class="box-content">
              <img width="140" src="@/assets/img/inter/greenn.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'blitzpay' },
            }"
          >
            <div class="box-content">
              <img width="160" src="@/assets/img/inter/blitzpay.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'pagarme' },
            }"
          >
            <div class="box-content">
              <img width="160" src="@/assets/img/inter/pagarme.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'nuvemshop' },
            }"
          >
            <div class="box-content center flex middle column">
              <img width="240" src="@/assets/img/inter/nuvemshop.png"/>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'yampi' },
            }"
          >
            <div class="box-content box-content center flex middle column">
              <img width="130" src="@/assets/img/inter/yampi.png"/>
              <small class="tag" style="margin-top: 4px">LEGACY</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'custom-sales' },
            }"
          >
            <div class="box-content center flex middle column">
                <H4>WEBHOOK PERSONALIZADO - VENDAS</H4>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>

        <div class="item flex-1 box flex middle center-txt disabled-box">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'tray' },
            }"
            :event="''"
          >
            <div class="box-content center flex middle column">
              <img width="110" src="@/assets/img/inter/tray.png"/>
              <small class="tag" style="margin-top: 4px">EM BREVE</small>
            </div>
          </router-link>
        </div>

      </section>

      <section class="margin-top-l">
        <h3>API</h3>
      </section>

      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'open-api' },
            }"
          >
            <div class="box-content center flex middle column">
                <h3>API V1 - ÚNICO TRACKER</h3>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>
      </section>

      <section class="margin-top-l">
        <h3>CALL BACK</h3>
      </section>

      <section class="grid-flex wrap">
        <div class="item flex-1 box flex middle center-txt">
          <router-link
            :to="{
              name: 'ConfigIntegrationDetail',
              params: { slug: 'open-webhook' },
            }"
          >
            <div class="box-content center flex middle column">
                <h3>CALL BACK PERSONALIZADA</h3>
              <small class="tag" style="margin-top: 4px">NOVA</small>
            </div>
          </router-link>
        </div>
      </section>

      <section class="flex center-txt margin-top-l">
        <p>
          Não encontrou a integração que precisa? Envie sua sugestão para:
          <a href="mailto:contato@unicotracker.com.br"
            >contato@unicotracker.com.br</a
          >
        </p>
      </section>
    </div>
    <div v-else>
      <!-- marketing -->
      <facebook-ads v-if="slug === 'facebook-ads'"></facebook-ads>
      <google-ads v-if="slug === 'google-ads'"></google-ads>
      <tiktok-ads v-if="slug === 'tiktok-ads'"></tiktok-ads>

      <!-- sales -->
      <hotmart v-if="slug === 'hotmart'"></hotmart>
      <kiwify v-if="slug === 'kiwify'"></kiwify>
      <cakto v-if="slug === 'cakto'"></cakto>
      <bagy v-if="slug === 'bagy'"></bagy>
      <stripe v-if="slug === 'stripe'"></stripe>
      <shopify v-if="slug === 'shopify'"></shopify>
      <eduzz v-if="slug === 'eduzz'"></eduzz>
      <braip v-if="slug === 'braip'"></braip>
      <payt v-if="slug === 'payt'"></payt>
      <doppus v-if="slug === 'doppus'"></doppus>
      <cart-panda v-if="slug === 'cartpanda'"></cart-panda>
      <perfect-pay v-if="slug === 'perfectpay'"></perfect-pay>
      <yampi v-if="slug === 'yampi'"></yampi>
      <yampiv2 v-if="slug === 'yampiv2'"></yampiv2>
      <monetizze v-if="slug === 'monetizze'"></monetizze>
      <evermart v-if="slug === 'evermart'"></evermart>
      <greenn v-if="slug === 'greenn'"></greenn>
      <blitzpay v-if="slug === 'blitzpay'"></blitzpay>
      <pagarme v-if="slug === 'pagarme'"></pagarme>
      <app-max v-if="slug === 'appmax'"></app-max>
      <witure v-if="slug === 'witure'"></witure>
      <kirvano v-if="slug === 'kirvano'"></kirvano>
      <lastlink v-if="slug === 'lastlink'"></lastlink>
      <lojaintegrada v-if="slug === 'lojaintegrada'"></lojaintegrada>
      <digital-guru v-if="slug === 'digitalguru'"></digital-guru>
      <nuvemshop v-if="slug === 'nuvemshop'"></nuvemshop>
      <woocommerce v-if="slug === 'woocommerce'"></woocommerce>
      <click-bank v-if="slug === 'clickbank'"></click-bank>
      <moovin v-if="slug === 'moovin'"></moovin>
      <lpqv v-if="slug === 'lpqv'"></lpqv>
      <hubla v-if="slug === 'hubla'"></hubla>
      <vega-checkout v-if="slug === 'vegacheckout'"></vega-checkout>
      <ticto v-if="slug === 'ticto'"></ticto>
      <custom-sales v-if="slug === 'custom-sales'"></custom-sales>

      <!-- captacao leads -->
      <active-campaign v-if="slug === 'active-campaign'"></active-campaign>
      <lead-lovers v-if="slug === 'lead-lovers'"></lead-lovers>
      <custom-leads v-if="slug === 'custom-leads'"></custom-leads>
      
      <!-- message -->
      <tintim v-if="slug === 'tintim'"></tintim>
      <umbler v-if="slug === 'umbler'"></umbler>
      <max-bot v-if="slug === 'maxbot'"></max-bot>
      <custom-mensagens v-if="slug === 'custom-mensagens'"></custom-mensagens>

      <!-- open apis -->
      <open-api v-if="slug === 'open-api'"></open-api>

      <!-- webhooks -->
      <open-webhook v-if="slug === 'open-webhook'"></open-webhook>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import FacebookAds from "./integrations/FacebookAds";
import GoogleAds from "./integrations/GoogleAds";
import TiktokAds from "./integrations/TiktokAds";
import Hotmart from "./integrations/Hotmart";
import Kiwify from "./integrations/Kiwify";
import Cakto from "./integrations/Cakto";
import Ticto from "./integrations/Ticto";
import Bagy from "./integrations/Bagy";
import Shopify from "./integrations/Shopify";
import Eduzz from "./integrations/Eduzz";
import PerfectPay from "./integrations/PerfectPay";
import Yampi from "./integrations/Yampi";
import Yampiv2 from "./integrations/Yampiv2";
import Braip from "./integrations/Braip";
import Payt from "./integrations/Payt";
import Doppus from "./integrations/Doppus";
import Monetizze from "./integrations/Monetizze";
import Evermart from "./integrations/Evermart";
import Greenn from "./integrations/Greenn";
import Blitzpay from "./integrations/Blitzpay";
import Pagarme from "./integrations/Pagarme";
import CartPanda from "./integrations/CartPanda";
import AppMax from "./integrations/AppMax";
import Witure from "./integrations/Witure";
import DigitalGuru from "./integrations/DigitalGuru";
import Kirvano from "./integrations/Kirvano";
import Lastlink from "./integrations/Lastlink";
import Lojaintegrada from "./integrations/Lojaintegrada";
import ActiveCampaign from "./integrations/ActiveCampaign";
import LeadLovers from "./integrations/LeadLovers";
import Nuvemshop from "./integrations/Nuvemshop";
import Stripe from "./integrations/Stripe";
import Woocommerce from "./integrations/Woocommerce";
import ClickBank from "./integrations/ClickBank";
import Moovin from "./integrations/Moovin";
import Lpqv from "./integrations/Lpqv";
import Hubla from "./integrations/Hubla";
import VegaCheckout from "./integrations/VegaCheckout";
import CustomSales from "./integrations/CustomSales";
import CustomLeads from "./integrations/CustomLeads";


// message
import Tintim from "./integrations/Tintim";
import Umbler from "./integrations/Umbler";
import MaxBot from "./integrations/MaxBot";
import CustomMensagens from "./integrations/CustomMensagens";

// open api
import OpenApi from "./integrations/OpenApi";

// open webhook
import OpenWebhook from "./integrations/OpenWebhook";

export default {
  name: "config-integration",
  components: {
    FacebookAds,
    GoogleAds,
    TiktokAds,
    Hotmart,
    Kiwify,
    Bagy,
    Cakto,
    Shopify,
    Eduzz,
    Monetizze,
    Evermart,
    Greenn,
    Blitzpay,
    Pagarme,
    PerfectPay,
    Yampi,
    Yampiv2,
    Braip,
    Doppus,
    CartPanda,
    AppMax,
    Payt,
    Witure,
    DigitalGuru,
    Kirvano,
    Lastlink,
    Lojaintegrada,
    ActiveCampaign,
    LeadLovers,
    Nuvemshop,
    OpenApi,
    Stripe,
    Tintim,
    OpenWebhook,
    Lpqv,
    Hubla,
    VegaCheckout,
    CustomMensagens,
    CustomSales,
    CustomLeads,
    Umbler,
    Woocommerce,
    ClickBank,
    Moovin,
    Ticto,
    MaxBot
  },
  props: ["slug"],
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  min-width: 300px;
  min-height: 130px;
  margin-top: 16px;
  margin-left: 0px !important;
  margin-right: 20px;

  .box-content {
    cursor: pointer;
  }

  a {
    width: 100%;
    height: 100%;
  }
}

.disabled-box {
  background: #e8e8e8;
  > a {
    cursor: none;
  }
}

.tag {
  background: var(--primary);
  color: #fff;
  padding: 4px 12px;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 600;
}
</style>
